import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Weights, OpportunityScore } from '@/types/opportunity';
import SaveAssessmentButton from './SaveAssessmentButton';
import ShareAssessmentButton from './ShareAssessmentButton';
import { Button } from '@/components/shared/button';
import { PencilLine } from 'lucide-react';
import { useAssessment } from '@/contexts/AssessmentContext';

interface AssessmentActionButtonsProps {
  weights: Weights;
  scoredOpportunities: OpportunityScore[];
  isEditing?: boolean;
}

const AssessmentActionButtons = ({ 
  weights, 
  scoredOpportunities, 
  isEditing = false 
}: AssessmentActionButtonsProps) => {
  const navigate = useNavigate();
  const { setCurrentStep } = useAssessment();

  const handleUpdateClick = () => {
    setCurrentStep(1); // Reset to first step
    navigate('/assessment/wizard');
  };

  return (
    <div className="flex justify-end gap-4">
      {isEditing ? (
        <SaveAssessmentButton 
          weights={weights}
          scoredOpportunities={scoredOpportunities}
        />
      ) : (
        <Button
          variant="outline"
          onClick={handleUpdateClick}
          className="gap-2"
        >
          <PencilLine className="w-4 h-4" />
          Update Opportunities
        </Button>
      )}
      <ShareAssessmentButton 
        weights={weights}
        scoredOpportunities={scoredOpportunities}
      />
    </div>
  );
};

export default AssessmentActionButtons;